import { render, staticRenderFns } from "./CustomersSegmentsFilterRFMTooltip.vue?vue&type=template&id=f2a6f8da&"
import script from "./CustomersSegmentsFilterRFMTooltip.vue?vue&type=script&lang=js&"
export * from "./CustomersSegmentsFilterRFMTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports